module.exports = __webpack_public_path__ + "2fff649c8b6ad9e94742a5fddaa966a3.png";